import { NavLink } from 'react-router';
import { cx } from '../lib/cx';

export interface TabItem {
  to: string;
  label: string;
  end?: boolean;
}

/**
 * Tabovi su LINKOVI, ne toggle klase.
 * URL je izvor istine za stanje — ARHITEKTURA.md sekcija 1 (`S.tabKlik` bug).
 */
export function Tabs({ items, className }: { items: readonly TabItem[]; className?: string }) {
  return (
    <nav className={cx('flex gap-1 overflow-x-auto border-b border-line-subtle', className)}>
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            cx(
              'whitespace-nowrap px-4 py-3 text-[14px] transition-colors duration-200',
              '-mb-px border-b-2',
              isActive
                ? 'border-accent text-accent-dark'
                : 'border-transparent text-ink-muted hover:text-ink',
            )
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
